import React from 'react';
import { Backdrop, CircularProgress } from '@mui/material';

const FullPageLoader = () => (
    <Backdrop
        sx={{
            color: '#f7ad19',
            zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open
    >
        <CircularProgress color="inherit" />
    </Backdrop>
);

export default FullPageLoader;
